export default class UserAcceptablePaymentTermService {
  constructor($http) {
    this.$http = $http;
  }

  update(user_id, terms) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_user_acceptable_payment_terms',
      data: {user_id: user_id, terms: terms, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }
}

UserAcceptablePaymentTermService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/user-acceptable-payment-term.service.js